<template>
  <div>
    <div
      v-if="showExtraDimensions"
      class="more-less-option bottom-padding"
      @click="showExtraDimensions=false">
      <OpenDropdownIcon :color="color"/>
      View Less
    </div>
    <div
      v-else
      class="more-less-option"
      @click="showExtraDimensions=true">
      <PageRightIcon :color="color"/>
      View More
    </div>
    <slot
      v-if="showExtraDimensions"
    ></slot>
  </div>
</template>
<script>
import {
  OpenDropdownIcon,
  PageRightIcon,
} from '@mikmak/components';

export default {
  data() {
    return {
      showExtraDimensions: false,
      color: '#4369F4',
    };
  },
  components: {
    OpenDropdownIcon,
    PageRightIcon,
  },
};
</script>
<style scoped>
.more-less-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #4369F4;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
}
.bottom-padding {
  padding-bottom: 16px;
}
</style>
